/**
 * Count-up maths for the stats card, kept out of the hook so the easing is
 * testable without fake rAF.
 */

/** Decelerating ease — fast off the mark, settles gently on the number. */
export const easeOutCubic = (t: number): number => {
  const clamped = Math.min(Math.max(t, 0), 1)
  return 1 - Math.pow(1 - clamped, 3)
}

/**
 * Value at progress `t` (0..1) between `from` and `to`.
 *
 * At t = 1 this returns `to` EXACTLY rather than an interpolated near-miss —
 * the last frame a player reads has to be the real number, not 52.99999.
 */
export const countUpValue = (from: number, to: number, t: number): number => {
  if (t >= 1) return to
  return from + (to - from) * easeOutCubic(t)
}
